const VISITOR_ID_COOKIE_NAME = "hi_visitor_id";

const SEGMENT_ANONYMOUS_ID_COOKIE_NAME = "ajs_anonymous_id";

/** Request header set by middleware for same-request SSR flag evaluation. */
const VISITOR_ID_REQUEST_HEADER = "x-hi-visitor-id";

/** Upper bound for cookie-stored anonymous ids (Segment allows custom strings). */
const VISITOR_ID_MAX_LENGTH = 128;

export {
  SEGMENT_ANONYMOUS_ID_COOKIE_NAME,
  VISITOR_ID_COOKIE_NAME,
  VISITOR_ID_MAX_LENGTH,
  VISITOR_ID_REQUEST_HEADER,
};
